var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlumbingSanitary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0.25H5.25V1.75C5.25 1.88261 5.19732 2.00979 5.10355 2.10355C5.00979 2.19732 4.88261 2.25 4.75 2.25H0.75C0.617392 2.25 0.490215 2.19732 0.396447 2.10355C0.302678 2.00979 0.25 1.88261 0.25 1.75V0.25Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4H2.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.25L1.25 4V11.75C1.25 12.8109 1.67143 13.8283 2.42157 14.5784C3.17172 15.3286 4.18913 15.75 5.25 15.75H5.5C6.56087 15.75 7.57828 15.3286 8.32843 14.5784C9.07857 13.8283 9.5 12.8109 9.5 11.75V10.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 2.25L4.25 4V11.75C4.25 12.0152 4.35536 12.2696 4.54289 12.4571C4.73043 12.6446 4.98478 12.75 5.25 12.75H5.5C5.76522 12.75 6.01957 12.6446 6.20711 12.4571C6.39464 12.2696 6.5 12.0152 6.5 11.75V10.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5H6C5.86193 8.5 5.75 8.61193 5.75 8.75V10.25C5.75 10.3881 5.86193 10.5 6 10.5H10C10.1381 10.5 10.25 10.3881 10.25 10.25V8.75C10.25 8.61193 10.1381 8.5 10 8.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.5V7.25C6.5 6.18913 6.92143 5.17172 7.67157 4.42157C8.42172 3.67143 9.43913 3.25 10.5 3.25V3.25L12.25 2.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5V7.25C9.5 6.98478 9.60536 6.73043 9.79289 6.54289C9.98043 6.35536 10.2348 6.25 10.5 6.25V6.25L12.25 6.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.25C12.6174 7.25 12.4902 7.19732 12.3964 7.10355C12.3027 7.00979 12.25 6.88261 12.25 6.75V2.75C12.25 2.61739 12.3027 2.49021 12.3964 2.39645C12.4902 2.30268 12.6174 2.25 12.75 2.25H14.25V6.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.25V4.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.75C12.75 9 13.125 8.5675 13.5 8.32312C13.9825 8.01062 14.25 7.44813 14.25 6.875V6.5C14.25 6.5 15.75 7.75 15.75 9.75C15.75 10.1478 15.592 10.5294 15.3107 10.8107C15.0294 11.092 14.6478 11.25 14.25 11.25C13.8522 11.25 13.4706 11.092 13.1893 10.8107C12.908 10.5294 12.75 10.1478 12.75 9.75Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbingSanitary);
export default __webpack_public_path__ + "static/media/plumbing-sanitary.6e0d24e4.svg";
export { ForwardRef as ReactComponent };